import { replace } from 'react-router-redux';

import apiCompleteElectionReminder from '../../utils/electionReminder/electionReminderCompleteApi';

import {
    EMAIL_COLLECTED,
    SHOW_NEXT_ACTION_ANIMATION,
    IS_NEXT_ACTION_TRANSITION,
    onFinishMultiAction
} from '../Widget/actions';

export const ELECTION_REMINDER_INITIATED = 'ELECTION_REMINDER_INITIATED';
export const ELECTION_REMINDER_SUBMITTING = 'ELECTION_REMINDER_SUBMITTING';
export const ELECTION_REMINDER_ERROR = 'ELECTION_REMINDER_ERROR';
export const ELECTION_REMINDER_COMPLETED = 'ELECTION_REMINDER_COMPLETED';
export const ELECTION_REMINDER_CANCELED = 'ELECTION_REMINDER_CANCELED';
export const SET_SUCCESS_INFO = 'SET_SUCCESS_INFO';

let toasterTimeout = null;

export const onGoToForm = (actionIdentifier, actionInitiated) => dispatch => {
    if (!actionInitiated) {
        dispatch({
            type: ELECTION_REMINDER_INITIATED,
            payload: actionIdentifier
        });
    }
    dispatch({
        type: SHOW_NEXT_ACTION_ANIMATION
    });

    dispatch({
        type: IS_NEXT_ACTION_TRANSITION,
        payload: true
    });

    dispatch({
        type: IS_NEXT_ACTION_TRANSITION,
        payload: true
    });

    dispatch({
        type: SHOW_NEXT_ACTION_ANIMATION
    });

    dispatch(replace('/electionReminder/details'));
};

export const onGoToStartScreen = actionIdentifier => dispatch => {
    dispatch({
        type: ELECTION_REMINDER_CANCELED,
        payload: actionIdentifier
    });

    dispatch(replace('/electionReminder'));
};

export const submitElectionReminderForm = (
    apiRequestData,
    values,
    isMultiActionsCard,
    actionIdentifier,
    actionCompletedTime,
    skipEndCard
) => dispatch => {
    dispatch({
        type: ELECTION_REMINDER_SUBMITTING,
        payload: { isFormSubmitting: true }
    });

    apiCompleteElectionReminder(apiRequestData, values, actionCompletedTime)
        .then(data => {
            if (isMultiActionsCard) {
                onFinishMultiAction(actionIdentifier)(dispatch);
            } else if (!skipEndCard) {
                dispatch(replace('/electionReminder/success'));
            }

            dispatch({
                type: ELECTION_REMINDER_SUBMITTING,
                payload: { isFormSubmitting: false }
            });

            dispatch({
                type: SET_SUCCESS_INFO,
                payload: { actionIdentifier }
            });

            dispatch({
                type: ELECTION_REMINDER_COMPLETED,
                payload: {
                    ...data,
                    actionIdentifier
                }
            });

            if (values.getUpdates) {
                dispatch({
                    type: EMAIL_COLLECTED,
                    payload: true
                });
            }
        })
        .catch(data => {
            let errorMessage;
            if (data.message) {
                errorMessage =
                    'An error has occured. ' +
                    (data.modelState !== undefined
                        ? Object.values(data.modelState)[0].toString()
                        : 'Please try again later!');
            } else {
                errorMessage =
                    'There was an error while submitting your form! Please try again later!';
            }

            dispatch({
                type: ELECTION_REMINDER_ERROR,
                payload: errorMessage
            });

            if (toasterTimeout != null) {
                clearTimeout(toasterTimeout);
                toasterTimeout = null;
            }

            toasterTimeout = setTimeout(() => {
                toasterTimeout = null;
                dispatch({
                    type: ELECTION_REMINDER_ERROR,
                    payload: null
                });
            }, 5000);

            dispatch({
                type: ELECTION_REMINDER_SUBMITTING,
                payload: { isFormSubmitting: false }
            });
        });
};
